import React from "react";
import styled from "styled-components";

const SignupMessage = styled.div`
  font-size: 1rem;
  font-weight: 900;
  color: #323232;
  text-align: center;
  margin-top: 2rem;
`;

/**
 * "Slow down" rate-limited screen with a retry button. Mirrors monolith
 * lines 1180–1202.
 */
export const RateLimitedState: React.FC<{ message: string; onRetry: () => void }> = ({
  message,
  onRetry,
}) => (
  <SignupMessage>
    <h3>Slow down</h3>
    <p>{message || "Too many refreshes. Please wait a minute."}</p>
    <button
      type="button"
      onClick={onRetry}
      style={{
        marginTop: "15px",
        padding: "8px 16px",
        background: "#444",
        color: "white",
        border: "none",
        cursor: "pointer",
        borderRadius: "4px",
      }}
    >
      Try again
    </button>
  </SignupMessage>
);

export default RateLimitedState;
